import React from 'react';
import { message } from 'antd';
import { connect } from 'react-redux';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { updateInternalWorkspaceAttachmentsForSupplier } from '../../thunks/work_orders_thunks';
import { getInternalNotesChannelId } from '../../utils/WorkOrderUtils';
import FileUploader from '../file_uploader/FileUploader';

interface InternalWorkspaceAttachmentsTabProps {
	workOrder: any;
	internalMessages: any;
	updateInternalWorkspaceAttachments: (payload: { id: string; attachments: any[] }) => Promise<any>;
}

const InternalWorkspaceAttachmentsTab = ({
	workOrder,
	internalMessages,
	updateInternalWorkspaceAttachments,
}: InternalWorkspaceAttachmentsTabProps) => {
	// Always read from the messages slice populated by fetchInternalWorkspace.
	// The API returns attachments under `internalAttachments` for all WO types.
	const attachments = nullSafeGetOrElse('internalAttachments', internalMessages, []);

	const saveAttachments = (newAttachments) =>
		updateInternalWorkspaceAttachments({ id: workOrder.id, attachments: newAttachments });

	const handleAttachmentUpdateFailure = () => {
		message.error('Failed to upload document');
	};

	const handleAttachmentUpload = (newAttachments) => {
		const callUpdate = newAttachments.every(
			(element) => element && element.fileId && element.fileName
		);
		if (!callUpdate) return;

		const savePromise = saveAttachments(newAttachments);
		if (savePromise && typeof savePromise.catch === 'function') {
			savePromise.catch(handleAttachmentUpdateFailure);
		}
	};

	return (
		<div className="flex flex-col">
			{/* File Uploader */}
			<div className="mb-4">
				<FileUploader
					defaultFileList={attachments}
					roleType="supplier"
					handleUploadSuccess={handleAttachmentUpload}
					uploaderType={'dragger'}
					multiple
				/>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const workOrder = state.work_orders.detail;
	const woId = nullSafeGet('id', workOrder);
	const channelId = woId ? getInternalNotesChannelId(woId) : null;
	return {
		workOrder,
		internalMessages: channelId ? state.messages[channelId] : null,
	};
};

const mapDispatchToProps = (dispatch) => ({
	updateInternalWorkspaceAttachments: (payload) =>
		dispatch(updateInternalWorkspaceAttachmentsForSupplier(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InternalWorkspaceAttachmentsTab);
